<template>
  <div class="min-h-screen transition-colors duration-300 bg-slate-50/50 dark:bg-slate-950 font-sans text-slate-800 dark:text-slate-200 flex">

    <Sidebar :isOpen="isSidebarOpen" />

    <div
      class="flex-1 flex flex-col min-w-0 transition-all duration-300 ease-[cubic-bezier(0.25,0.8,0.25,1)]"
      :class="isSidebarOpen ? 'ml-72' : 'ml-20'"
    >

      <header class="h-16 sticky top-0 z-20 px-8 flex items-center justify-between
                     bg-white/70 backdrop-blur-xl border-b border-slate-200/60
                     dark:bg-slate-900/80 dark:border-slate-800
                     supports-[backdrop-filter]:bg-white/60">

        <div class="flex items-center gap-4">
          <button
            @click="toggleSidebar"
            class="p-2 -ml-2 rounded-lg transition-colors
                   text-slate-500 hover:text-brand-600 hover:bg-brand-50
                   dark:text-slate-400 dark:hover:text-brand-400 dark:hover:bg-brand-500/10"
          >
            <Menu class="w-5 h-5" />
          </button>

          <h2 class="text-sm font-medium text-slate-500 dark:text-slate-500">
            Suite / <span class="text-slate-800 dark:text-slate-200">Dashboard</span>
          </h2>
        </div>

        <!-- <div class="flex items-center gap-4">
          <div class="relative hidden sm:block group">
            <Search class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 transition-colors
                           text-slate-400 group-focus-within:text-brand-500
                           dark:text-slate-500 dark:group-focus-within:text-brand-400" />

            <input
              type="text"
              placeholder="Buscar..."
              class="pl-10 pr-4 py-2 w-64 rounded-full text-sm transition-all outline-none
                     bg-slate-100/50 border border-slate-200
                     focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500
                     dark:bg-slate-950 dark:border-slate-700 dark:placeholder-slate-600 dark:text-slate-200
                     dark:focus:ring-brand-400/20 dark:focus:border-brand-400"
            >
          </div>

          <button class="relative p-2 rounded-full transition-colors
                         text-slate-400 hover:text-slate-600 hover:bg-slate-100
                         dark:text-slate-400 dark:hover:text-slate-200 dark:hover:bg-slate-800">
            <Bell class="w-5 h-5" />

            <span class="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-white dark:border-slate-900"></span>
          </button>
        </div> -->
      </header>

      <main class="flex-1 p-8">
        <slot></slot>
      </main>

    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Sidebar from '@/components/layout/Sidebar.vue';
import { Menu, Search, Bell } from 'lucide-vue-next';

const isSidebarOpen = ref(true);
const toggleSidebar = () => isSidebarOpen.value = !isSidebarOpen.value;
</script>
